

export const Environment = {
  /**
   * Define a quantidade de linhas a ser carregada por padrão nas listagens
   */
  LIMITE_DE_LINHAS: 5,
  /**
   * Define o tamanho de Sidebar do filtro de listagem
   */
  TAMANHO_DO_DRAWER_LIST: 300,
  /**
   * Define o tamanho de Sidebar do Menu
   */
  TAMANHO_DO_DRAWER_MENU: 250,
};
